import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./SecurityPin.template.vue";

@Component({
  mixins: [Template]
})
export default class SecurityPinModalComponent extends Vue {
  @Prop() public description!: string;

  protected pin: string | null = null;

  public resolve() {
    this.$emit("resolve", this.pin);
  }
}
